import { mdiTownHall } from '@mdi/js'

export default {
  title: 'School',
  to: 'school-admin-list',
  icon: mdiTownHall,
  action: 'read',
  resource: 'SchoolSchool',
}
